import { SelectValueLabel } from 'common/types/SelectValueLabel';
import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { ReminderCategoriesDto } from './models/ReminderCategoriesDto';
import { ReminderCategoriesSearchCriteria } from './models/ReminderCategoriesSearchCriteria';

class ReminderCategoriesService {
    public getList(criteria: ReminderCategoriesSearchCriteria) {
        return Http.get<Paged<ReminderCategoriesDto>>('remindercategories', criteria);
    }

    public getById(id: string) {
        return Http.get<ReminderCategoriesDto>('remindercategories/' + id);
    }

     public getByLabel(label: string) {
        return Http.get<ReminderCategoriesDto>('remindercategories/get-by-label/' + label);
    }

    public create(model: ReminderCategoriesDto) {
        return Http.post<string>('remindercategories', model);
    }

    public update(model: ReminderCategoriesDto) {
        return Http.put('remindercategories', model);
    }

    public remove(model: ReminderCategoriesDto) {
        return Http.put('remindercategories/deactivate', model);
    }
   
    public catalog(criteria: ReminderCategoriesSearchCriteria ) {
        return Http.get<SelectValueLabel[]>(`remindercategories/catalog`, criteria);
    }

    public catalogByReminders() {
        return Http.get<ReminderCategoriesDto[]>(`remindercategories/catalog-by-reminders`);
    }
    
}

export default new ReminderCategoriesService();